import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  amount: Yup.number().min(0).required(),
  description: Yup.string().required(),
});

export const initialValues = (appId: number) => ({
  id: 0,
  loan_application_id: appId,
  created_at: "",
  description: "",
  amount: "0",
});
